import { retrieveBackendSession } from "@/backend/impl/backendSessionCache";
import type { CreateSessionRequest } from "@/backend/natsstubs/onboarding/models";
import { loadSessions } from "@/backend/read/BackendReader";
import { useCompanyStore } from "@/store/company";

import type { OnboardSessionParams } from "../types";

export function useOnboardSession() {
  async function createSession(params: OnboardSessionParams): Promise<string> {
    const session = retrieveBackendSession();
    if (!session) {
      throw new Error("Backend session not initialized");
    }

    const result = await session.createOnboardingSession({
      sessionName: params.sessionName.trim(),
      teams: params.teams.map((t) => t.name) as CreateSessionRequest["teams"],
      iterations: params.iterations.map((i) => i.name) as CreateSessionRequest["iterations"],
      presetId: params.presetId,
    });

    // Success - cleanup
    useCompanyStore().setCompany({ id: "", name: "", shouldOnboard: false });

    // Load sessions into the store before navigating, so the route guard
    // finds the newly created session instead of falling through to noSession()
    await loadSessions();

    return result.sessionId;
  }

  return { createSession };
}
